import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DeliveryTypeWrapper } from './DeliveryType.styles';
import IntlMessages from '@iso/components/utility/intlMessages';

import localEatsActions from '@iso/redux/localEats/actions';

const DeliveryType = ({ marketplace }) => {
  const dispatch = useDispatch();
  const [deliveryType, setDeliveryType] = useState(
    localStorage.getItem('delivery-type') || 'courier'
  );

  const changeDeliveryType = (type) => {
    // localStorage.removeItem('delivery-type');
    setDeliveryType(type);
    localStorage.setItem('delivery-type', type);
    dispatch(localEatsActions.fetchMarketplaceBrandsStart(marketplace));
  };

  return (
    <DeliveryTypeWrapper>
      <p
        className={deliveryType.toString() === 'courier' ? 'active' : ''}
        onClick={() => changeDeliveryType('courier')}
      >
        <IntlMessages id="filter.delivery" />
      </p>

      <p
        className={deliveryType.toString() === 'take-away' ? 'active' : ''}
        onClick={() => changeDeliveryType('take-away')}
      >
        <IntlMessages id="filter.pickup" />
      </p>
    </DeliveryTypeWrapper>
  );
};

export default DeliveryType;
